import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import {
	MatButtonModule,
	MatIconModule,
	MatFormFieldModule,
	MatInputModule,
	MatSnackBarModule
} from '@angular/material';
import { BillComponent } from './bill.component';
import { ErrorMessageModule } from './error-message/error-message.module';
import { BillFieldDirective } from './bill-field.directive';
import { CloneComponent } from './clone/clone.component';
import { TrueFalseValueDirective } from './truefalse-value.directive';

@NgModule({
	declarations: [BillComponent, BillFieldDirective, CloneComponent, TrueFalseValueDirective],

	imports: [
		CommonModule,
		MatButtonModule,
		MatIconModule,
		MatFormFieldModule,
		MatInputModule,
		ReactiveFormsModule,
		MatSnackBarModule,
		FormsModule,
		ErrorMessageModule
	],
	exports: [BillComponent, BillFieldDirective,TrueFalseValueDirective, ReactiveFormsModule],
	entryComponents: [CloneComponent]
})
export class BillModule {}
